<template>
  <v-toolbar app color="primary">
    <v-toolbar-title v-t="'title'" class="hidden-xs-only"></v-toolbar-title>
    <v-toolbar-title v-t="'short_title'" class="hidden-sm-and-up"></v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu offset-y>
      <v-btn icon slot="activator">
        <v-icon>language</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile @click="language = 'ja'">
          <v-list-tile-title v-t="'languages.ja'"></v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="language = 'en'">
          <v-list-tile-title v-t="'languages.en'"></v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-btn icon @click.stop="$store.dispatch('refreshFiat')">
      <v-icon>refresh</v-icon>
    </v-btn>
    <v-btn icon @click.stop="$store.commit('toggleCamera')">
      <v-icon v-if="$store.state.camera">clear</v-icon>
      <v-icon v-else>camera_alt</v-icon>
    </v-btn>
    <v-btn icon @click.stop="$store.commit('toggleHelp')">
      <v-icon>help</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  data () {
    return {
      language: 'ja'
    }
  },
  watch: {
    language: function () {
      this.$i18n.locale = this.language
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Toolbar.vue